import "./AboutMe.scss"
import { about__img } from "../../service/image"
import FadeIn from "../../components/FadeIn/FadeIn"

const Section = ({ children }) => {
    const [ref, isVisible] = FadeIn(0.2);
    return (
      <section ref={ref} className={`fade-in-section ${isVisible ? "visible" : ""}`}>
        {children}
      </section>
    )
  }

const AboutMe = () => {

    return(
        <Section>
        <section className="about-me">
         <div className="container">
            <div className="about__items">
                <div className="about__item">
                  <b>Erik Yeghiazaryan</b>
                  <p>Front End Developer</p>
                </div>

                <div className="about__item">
                    <div className="about__img">
                        <img src={about__img} alt="Erik Yeghiazaryan image" />
                    </div>
                </div>

                <div className="about__item">
                    <div className="about__mail">
                <a href="mailto:goodprogramwork@gmail.com">goodprogramwork@gmail.com</a>
                    </div>
                <p>City ​​of Marseille</p>
                </div>
            </div>

            <i>Hello, How I Became a Frontend Developer?</i>

            <p>
            Back in high school, I first heard about web development completely by chance. 
            My friends and I were discussing what we wanted to do in the future, and one of 
            them mentioned his dream of becoming a "web developer." I honestly admitted I had 
            no idea what that meant. He explained that it’s someone who creates websites and added, 
            “It’s probably the coolest job—you sit at your computer, write code, and create something 
            that millions of people can see!” For some reason, those words stuck with me. <br />

At that time, I never imagined I’d pursue it myself. I dreamed of becoming an athlete and was regularly 
attending fitness training sessions. However, life had other plans for me. <br />

After graduating from school, I didn’t get accepted to the program I wanted. Looking for something to fill 
my time until the next year, I remembered that conversation with my classmate and decided to explore how websites are made.
 I opened YouTube and typed something like, “how to create a website from scratch.” A man appeared on the screen, explaining
  how to build a simple HTML page. I didn’t understand much of what he said, but one phrase struck me: “Web development is not
   just code—it’s an art form.” <br />

I started small. My early attempts were dreadful: a page with a green background, yellow text, and a terribly blinking button that said,
 “Click me.” When I showed it to my friends, they laughed for ages, but I felt a spark of determination. I wanted to prove to them—and to 
 myself—that I could do better. I downloaded my first free book on HTML and CSS, and soon discovered JavaScript. That opened a whole new world
  of dynamic interactions and logic. I immersed myself in lessons, Googled relentlessly, and tried coding every day. Every time my code worked,
   I felt an incredible sense of achievement. <br />

A year later, I wasn’t just playing around with code anymore—I created my first real website for a friend who sold souvenirs. It was a simple
 one-pager, but it looked polished: clean design, cool buttons, and smooth animations. My friend even paid me for it! That was my first earnings 
 as a Frontend Developer. <br />

Later, I enrolled in a physical education university to study “Boxing Coaching,” but quickly realized how hard it was to balance studying and
 working. Instead, I focused on online courses and real-world projects to improve my skills. Over time, I mastered React, learned how to work
  with APIs, and even dabbled in design to better collaborate with UI/UX designers. <br />

Today, I work remotely from anywhere in the world with my incredible team, which includes a Backend Developer and a UI/UX Designer.
 Every project is a new challenge, an opportunity to grow, and a chance to leave a little piece of myself in the digital world. <br />

That’s how I became a Frontend Developer. It all started with a tiny blinking button, and now I build interfaces used by thousands of people.
 And you know what? I wouldn’t change a thing.
            </p>
         </div>

        </section>
        </Section>

    )

}

export default AboutMe